import Dialog from '@material-ui/core/Dialog';
import logo from 'assets/images/gazit-logo.png';
import Logos from 'components/Shared/Logos';
import { WithStyles } from 'decorators/withStyles';
import * as React from 'react';
import { PureComponent } from 'react';
import SwipeableViews from 'react-swipeable-views';
import * as rxjsOperators from 'rxjs-operators';
import authService from 'services/auth';
import LoginDialogForm from './Form';
import LoginDialogRecoveryAccess from './RecoveryAcces';
import { AccessCodeForm } from './AccessCode';
import { RouterContext } from 'components/Router';

interface IState {
  opened: boolean;
  currentView: number;
}

interface IProps {
  classes?: any;
}

@WithStyles((theme) => ({
  root: {
    background: '#fff',
    minHeight: '100vh',
    minWidth: '100vw',
    position: 'relative',
  },
  container: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    margin: 'auto',
    width: 400,
    height: 500,
    maxWidth: 'calc(100% - 30px)',
    color: 'white',
  },
  logo: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  solidLogo: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    position: 'absolute',
    bottom: 0,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  logoImage: {
    maxWidth: '100%',
    marginRight: '12px',
  },
  viewContainer: {
    boxSizing: 'border-box',
    padding: '0 10px',
    height: 310,
  },
}))
export default class LoginDialog extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { opened: false, currentView: 0 };
  }

  componentDidMount() {
    authService
      .shouldOpenLogin()
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe((opened) => {
        this.setState({ opened });
      });
  }

  changeView = (view: number) => () => {
    this.setState({ currentView: view });
  };

  render() {
    const { opened, currentView } = this.state;
    const { classes } = this.props;

    return (
      <Dialog
        fullScreen
        disableBackdropClick
        disableEscapeKeyDown
        open={opened}
      >
        <RouterContext.Consumer>
          {(routerGetter) => {
            return (
              <div className={classes.root}>
                <div className={classes.container}>
                  <div className={classes.logo}>
                    <img src={logo} alt="logo" width="240" />
                  </div>

                  <SwipeableViews index={currentView}>
                    <div className={classes.viewContainer}>
                      <LoginDialogForm
                        onLoginSuccess={this.changeView(2)}
                        history={routerGetter().history}
                        onRecoveryAccess={this.changeView(1)}
                      />
                    </div>
                    <div className={classes.viewContainer}>
                      <LoginDialogRecoveryAccess
                        onCancel={this.changeView(0)}
                        onComplete={this.changeView(0)}
                      />
                    </div>
                    <div>
                      <AccessCodeForm onCancel={this.changeView(0)} />
                    </div>
                  </SwipeableViews>
                </div>
                <Logos absolute />
              </div>
            );
          }}
        </RouterContext.Consumer>
      </Dialog>
    );
  }
}
